import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clienti from "./pages/Clienti";
import ClienteDettaglio from "./pages/ClienteDettaglio";
import Ricerca from "./pages/Ricerca";
import Programmate from "./pages/Programmate";
import Caricamento from "./pages/Caricamento";
import Elaborazioni from "./pages/Elaborazioni";
import Registrazioni from "./pages/Registrazioni";
import Interessati from "./pages/Interessati";
import CommercialIntelligence from "./pages/CommercialIntelligence";
import Report from "./pages/Report";
import Archivio from "./pages/Archivio";
import Diagnostica from "./pages/Diagnostica";
import Log from "./pages/Log";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-sm text-neutral-500">Verifica sessione…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clienti" element={<Clienti />} />
              <Route path="/clienti/:id" element={<ClienteDettaglio />} />
              <Route path="/ricerca" element={<Ricerca />} />
              <Route path="/programmate" element={<Programmate />} />
              <Route path="/caricamento" element={<Caricamento />} />
              <Route path="/elaborazioni" element={<Elaborazioni />} />
              <Route path="/registrazioni" element={<Registrazioni />} />
              <Route path="/interessati" element={<Interessati />} />
              <Route path="/commercial-intelligence" element={<CommercialIntelligence />} />
              <Route path="/report" element={<Report />} />
              <Route path="/archivio" element={<Archivio />} />
              <Route path="/diagnostica" element={<Diagnostica />} />
              <Route path="/log" element={<Log />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
